import { Controller } from "@hotwired/stimulus"

const ICON_PLAY = `<svg viewBox="0 0 24 24" fill="currentColor" class="w-5 h-5 text-cyan-400 ml-0.5"><path d="M8 5v14l11-7z"/></svg>`
const ICON_STOP = `<svg viewBox="0 0 24 24" fill="currentColor" class="w-5 h-5 text-cyan-400"><path d="M6 6h12v12H6z"/></svg>`
const ICON_LOADING = `<svg viewBox="0 0 24 24" fill="none" class="w-5 h-5 text-cyan-400 animate-spin"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="2" stroke-dasharray="28 56" stroke-linecap="round"/></svg>`

export default class extends Controller {
  static targets = ["tile", "audio"]
  static values = { url: String }

  connect() {
    this.currentAudio = null
    this.currentBtn = null
    this.cache = {}
  }

  select(event) {
    this.tileTargets.forEach(tile => {
      tile.classList.remove("border-cyan-500", "bg-cyan-500/10")
      tile.classList.add("border-slate-700/50")
    })
    const label = event.target.closest("label")
    if (label) {
      label.classList.add("border-cyan-500", "bg-cyan-500/10")
      label.classList.remove("border-slate-700/50")
    }
  }

  async play(event) {
    event.preventDefault()
    event.stopPropagation()

    const btn = event.currentTarget
    const voiceKey = btn.dataset.voiceKey

    // If this button's audio is already playing, stop it
    if (this.currentBtn === btn && this.currentAudio && !this.currentAudio.paused) {
      this.currentAudio.pause()
      this.currentAudio.currentTime = 0
      this.setIcon(btn, ICON_PLAY)
      this.currentBtn = null
      return
    }

    // Stop whatever else is playing
    if (this.currentAudio) {
      this.currentAudio.pause()
      this.currentAudio.currentTime = 0
    }
    if (this.currentBtn) this.setIcon(this.currentBtn, ICON_PLAY)

    // Auto-select the tile
    const label = btn.closest("label")
    if (label) {
      const radio = label.querySelector("input[type=radio]")
      if (radio) {
        radio.checked = true
        radio.dispatchEvent(new Event("change", { bubbles: true }))
      }
    }

    this.setIcon(btn, ICON_LOADING)
    btn.disabled = true

    try {
      let audioUrl = this.cache[voiceKey]

      if (!audioUrl) {
        const response = await fetch(this.urlValue, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content
          },
          body: JSON.stringify({ voice_key: voiceKey })
        })

        const data = await response.json()
        if (data.error) throw new Error(data.error)
        audioUrl = data.audio_url
        this.cache[voiceKey] = audioUrl
      }

      const audio = this.audioTargets.find(a => a.dataset.voiceKey === voiceKey)
      if (audio) {
        audio.src = audioUrl
        await audio.play()
        this.currentAudio = audio
        this.currentBtn = btn
        this.setIcon(btn, ICON_STOP)

        audio.onended = () => {
          this.setIcon(btn, ICON_PLAY)
          this.currentBtn = null
        }
      }
    } catch (err) {
      console.error("Voice preview failed:", err)
      this.setIcon(btn, ICON_PLAY)
    } finally {
      btn.disabled = false
    }
  }

  setIcon(btn, svgString) {
    btn.innerHTML = svgString
  }
}